import { Drawer } from 'antd'
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import FieldInput from '../../../../../../components/Fields/FieldInput'
import { Button } from 'reactstrap'
import i18n from '../../../../../../lib/i18n'

// Stable identity: an inline validator re-registers the field and drops its sync error
const requiredTitle = value => (value && String(value).trim() ? undefined : i18n('is required'))

function FormData({open, onClose = () => {}, handleSubmit, onSave = () => {}, reset, submitting}) {
  return (
    <Drawer
      title={i18n('qn_subject_form')}
      placement="left"
      onClose={() => {
        reset();
        onClose()
      }}
      open={open}
    >
      <form onSubmit={handleSubmit(onSave)}>
        <Field component={FieldInput} name="title" label={i18n('qn_sb_name')} validate={requiredTitle} />
        <Button color="primary" disabled={submitting} style={{width: '100%', marginTop: 20}}>{i18n('bt_save')}</Button>
      </form>
    </Drawer>
  )
}
export default reduxForm({
  form: 'subject_folder',
  enableReinitialize: true,
  // reset() wipes syncErrors and the values do not change, so the default check never revalidates
  shouldError: () => true
})(FormData)